import { z } from 'zod'
import { ActorNameSchema } from '@/shared/lib'

// Владелец комментария — любая доменная сущность (generic-треды).
export const COMMENT_ENTITY_KINDS = [
  'project',
  'company',
  'document',
  'task',
  'invoice',
  'meeting',
] as const
export const CommentEntityKindSchema = z.enum(COMMENT_ENTITY_KINDS)
export type CommentEntityKind = z.infer<typeof CommentEntityKindSchema>

// Комментарий сущности. Плоский список — дерево тредов строит потребитель по
// parent_id. internal-комментарии заказчику не приходят (срез бэка).
// at_version — только у документных комментариев (к какой версии писали).
export const CommentSchema = z.object({
  id: z.string(),
  entity_kind: CommentEntityKindSchema,
  entity_id: z.string(),
  parent_id: z.string().optional(),
  author: ActorNameSchema,
  text: z.string(),
  at_version: z.number().optional(),
  resolved: z.boolean(),
  internal: z.boolean(),
  mentions: z.array(ActorNameSchema),
  parent_deleted: z.boolean().optional().default(false),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type Comment = z.infer<typeof CommentSchema>
